export const UPDATE_PARTNER_MUTATION = gql`
    mutation updatePartner($id: Int!, $input: UpdatePartnerInput!) {
        updatePartner(id: $id, input: $input) {
            id
            bank {
                bic
                iban
            }
            name
            notes {
                body
                id
                createdAt
                createdBy {
                    username
                }
            }
        }
    }
`;
